import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  Tab,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  ArrowBack,
  Circle,
  Check,
  Close as CloseIcon,
  PrintOutlined,
} from "@mui/icons-material";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import WorkPlan from "./WorkPlan/WorkPlan";
import WOView from "./WOView";
import WorkAssignment from "./WOAssignment/WorkAssignment";
import Completion from "./WOCompletion/Completion";
import ListMenuWO from "./SideMenu/ListMenuWO";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import WoCosting from "./WOCosting/WoCosting";
import { useSelector } from "react-redux";
import { defaultInfo, SubMenu, woStatus } from "../../../ConfigInfo/Info";
import { decode } from "../../../Component/JWT/Formatt";
import { toast } from "react-toastify";
import UnifiedModal from "../../../Component/UnifiedModal";
import Partlist from "./Parts/Partlist";
import { printWorkOrder } from "../../../Component/printWorkOrder";
import { usePrintLoader } from "../../../Component/usePrintLoader";

const WO = ({ ui }) => {
  const navigate = useNavigate();
  const subMenuList = useSelector((state) => state.dataRed.subMenuList);
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);
  const viewOnly =
    !actionsAllow.create && !actionsAllow.edit && !actionsAllow.delete;
  const [value, setValue] = useState("1");
  const [jobPlanId, setJobPlanId] = useState("");
  const [workOrderId, setWorkOrderId] = useState("");
  const [woData, setWoData] = useState({});
  const [dotBL, setDotBL] = useState(null);
  const [direction, setDirection] = useState("row");
  const [searchParams] = useSearchParams();
  const [refreshKey, setRefreshKey] = useState(0);
  const [enableDisble, setEnableDisable] = useState({
    task: {},
    labour: {},
    part: {},
  });
  const [isClosedStatus, setIsClosedStatus] = useState(false);
  const [approvalContext, setApprovalContext] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [approvalLevel, setApprovalLevel] = useState(null); // Add this
  const [rejectedDescription, setRejectedDescription] = useState(""); // Add this
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectDescription, setRejectDescription] = useState("");
  const [workFlowFor, setWorkFlowFor] = useState("");
  const [enableDisableActionAllow, setEnableDisableActionAllow] = useState({});
  const { runPrint, PrintLoader } = usePrintLoader();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    refreshEnableDisable();
  }, [woData, isClosedStatus]);
  const getData = async () => {
    const id = decode(searchParams.get("id"));
    const fromApproval = searchParams.get("fromApproval");
    const approvalId = searchParams.get("approvalId");

    // Store approval context if coming from approval page
    if (fromApproval === "true" && approvalId) {
      const decodedApprovalId = decode(approvalId);
      setApprovalContext({
        approvalId: decodedApprovalId,
        fromApproval: true,
      });
      // Fetch approval status
      fetchApprovalStatus(decodedApprovalId);
    }

    const wolink = masterAPI["workOrder"].completeDetail;
    await axiosPrivate
      .get(`${wolink}/${id}`)
      .then((res) => {
        console.log(res);
        // DataWO(res.data.result)
        setWoData(res.data.result);
        setJobPlanId(res.data.result.jobPlanId);
        setWorkOrderId(res.data.result.id);
        setRefreshKey((prevKey) => prevKey + 1);

        const isClosed = res.data.result.status?.toUpperCase() === woStatus.CLOSE;
        setIsClosedStatus(isClosed);
      })
      .catch((e) => {
        setWoData([]);
        setJobPlanId([]);
        setWorkOrderId([]);
        setIsClosedStatus(false);
        console.log(e, "workorderview");
      });

    const filterSubMenuListTask = subMenuList.filter(
      (fil) => fil.id === SubMenu.woTask,
    );
    const filterSubMenuListLabour = subMenuList.filter(
      (fil) => fil.id === SubMenu.woLabour,
    );
    const filterSubMenuListPart = subMenuList.filter(
      (fil) => fil.id === SubMenu.woPart,
    );
    setEnableDisable({
      task: filterSubMenuListTask.lenght === 0 ? {} : filterSubMenuListTask[0],
      labour:
        filterSubMenuListLabour.lenght === 0 ? {} : filterSubMenuListLabour[0],
      part: filterSubMenuListPart.lenght === 0 ? {} : filterSubMenuListPart[0],
    });
  };

  const fetchApprovalStatus = async (approvalId) => {
    if (!approvalId) return;

    const link = masterAPI["workFlowApproval"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const approvalRecord = res.data.result.find(
          (item) => item.id === approvalId,
        );
        if (approvalRecord) {
          setApprovalStatus(approvalRecord.status);
          setApprovalLevel(approvalRecord.workFlowLevel || null);
          setRejectedDescription(approvalRecord.description || "");
          setWorkFlowFor(approvalRecord.workFlowFor || ""); // Add this line to set workFlowFor
        }
      })
      .catch((e) => {
        console.log(e, "fetch approval status error");
      });
  };

  const handleApprove = async () => {
    if (!approvalContext?.approvalId) return;

    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Approved",
    };

    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then((res) => {
        console.log(res.data);
        setApprovalStatus(
          workFlowFor === "WorkOrderClose" ? "Approved to Close" : "Approved",
        );
        toast.success(
          `Request ${workFlowFor === "WorkOrderClose" ? "Approved to Close" : "Approved"} successfully`,
        );
        setTimeout(() => {
          navigate("/workflowapproval");
        }, 1500);
      })
      .catch((e) => {
        console.log(e, "approve error");
        toast.error(
          e.response?.data?.failureMessage || "Failed to approve request",
        );
      });
  };

  const handleReject = async () => {
    if (!approvalContext?.approvalId) return;
    if (!rejectDescription.trim()) {
      toast.error("Description is required to reject.");
      return;
    }
    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Rejected",
      description: rejectDescription,
    };
    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then((res) => {
        setApprovalStatus(
          workFlowFor === "WorkOrderClose" ? "Reopen" : "Rejected",
        );
        toast.success(
          `Request ${workFlowFor === "WorkOrderClose" ? "reopened" : "rejected"} successfully`,
        );
        setShowRejectModal(false);
        setRejectDescription("");
        setTimeout(() => {
          navigate("/workflowapproval");
        }, 1500);
      })
      .catch((e) => {
        toast.error(
          e.response?.data?.failureMessage || "Failed to reject request",
        );
      });
  };

  const getEffectiveEnableDisable = () => {
    const fromApproval = searchParams.get("fromApproval");
    const isStatus =
      woData.status?.toUpperCase() === woStatus.PAPPR ||
      woData.status?.toUpperCase() === woStatus.PPRAPPR ||
      woData.status?.toUpperCase() === woStatus.PENAPP ||
      woData.status?.toUpperCase() === woStatus.RESUBMIT ||
      woData.status?.toUpperCase() === woStatus.PRREJT;

    if (isClosedStatus || fromApproval || isStatus) {
      return {
        task: {
          ...enableDisble.task,
          create: false,
          edit: false,
          delete: false,
        },
        labour: {
          ...enableDisble.labour,
          create: false,
          edit: false,
          delete: false,
        },
        part: {
          ...enableDisble.part,
          create: false,
          edit: false,
          delete: false,
        },
      };
    }
    return enableDisble;
  };

  const getEffectiveActionsAllow = () => {
    const isStatus =
      woData.status?.toUpperCase() === woStatus.NEW ||
      woData.status?.toUpperCase() === woStatus.PAPPR ||
      woData.status?.toUpperCase() === woStatus.PENAPP ||
      woData.status?.toUpperCase() === woStatus.PPRAPPR ||
      woData.status?.toUpperCase() === woStatus.RESUBMIT ||
      woData.status?.toUpperCase() === woStatus.PRREJT;
    const fromApproval = searchParams.get("fromApproval");

    // Check if task list is empty
    const hasNoTasks =
      !woData.workOrderTaskList || woData.workOrderTaskList.length === 0;

    const allTasksHaveLabour = () => {
      // If no tasks exist, return false to prevent editing
      if (hasNoTasks) {
        return false;
      }

      if (
        !woData.workOrderTaskLabourList ||
        woData.workOrderTaskLabourList.length === 0
      ) {
        return false;
      }

      const result = woData.workOrderTaskList.every((task) => {
        const hasLabour = woData.workOrderTaskLabourList.some(
          (labour) => labour.workOrderTaskId === task.id,
        );
        return hasLabour;
      });

      return result;
    };

    const hasLabour = allTasksHaveLabour();
    console.log(
      isClosedStatus || hasNoTasks || isStatus || !hasLabour || fromApproval,
      fromApproval,
      isClosedStatus,
      hasNoTasks,
      isStatus,
      !hasLabour,
      "disable toggle condition",
    );
    // Disallow toggle/edit if: closed status, OR empty task list, OR (new status without labour)
    if (
      isClosedStatus ||
      hasNoTasks ||
      isStatus || !hasLabour ||
      fromApproval
    ) {
      return { create: false, edit: false, delete: false, view: true };
    } else {
      console.log(actionsAllow, "actions allow in else");
      // setEnableDisableActionAllow({...actionsAllow});
      return actionsAllow;
    }
  };

  const refreshEnableDisable = () => {
    const result = getEffectiveActionsAllow();
    setEnableDisableActionAllow(result);
  };

  const handleDot = (event) => {
    if (!dotBL) {
      setDotBL(event.currentTarget);
    } else {
      setDotBL(null);
    }
  };

  const contentPosition = (flex) => {
    setDirection(flex);
  };
  return (
    <Grid container spacing={"1rem"}>
      <Grid
        item
        xs={direction === "column" ? 6 : 9.5}
        md={direction === "column" ? 6 : 10.5}
        lg={direction === "column" ? 6 : 11}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: "1rem",
            gap: "1rem",
          }}
          // sx={{mb:"1rem"}}
        >
          <Grid sx={{ display: ui ? "none" : "default" }}>
            {approvalContext?.fromApproval ? (
              <IconButton onClick={() => navigate("/workflowapproval")}>
                <ArrowBack />
              </IconButton>
            ) : (
              <Link to="/workOrder">
                <IconButton>
                  <ArrowBack />
                </IconButton>
              </Link>
            )}
          </Grid>
          <Typography
            sx={{
              // color: color.masterDialogTitleColor,
              // fontSize: color.masterDialogFontSize,
              fontSize: color.AssetTitlesize,
              fontWeight: color.sideFontWeightAsset,
              display: ui ? "flex" : null,
              justifyContent: ui ? "center" : "space-between",
              width: ui ? "40%" : "100%",
              marginTop: ui ? "10px" : null,
            }}
          >
            Work Order : {woData.code} : {woData.workOrderName}
          </Typography>
          <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
              <Circle sx={{ fontSize: "0.5rem", color: "green" }} />
              <Typography>{woData.status}</Typography>
            </Box>
            {workOrderId && (
              <IconButton
                onClick={() =>
                  runPrint(
                    printWorkOrder,
                    workOrderId,
                    `${woData.code} - ${woData.workOrderName}`,
                  )
                }
                title="Print Work Order"
              >
                <PrintOutlined sx={{ color: color.TabLabelcolor }} />
              </IconButton>
            )}
            {woData?.reasonToCancel && !approvalContext?.fromApproval && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  minWidth: 220,
                }}
              >
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 2,
                    boxShadow: "0px 2px 8px #00000022",
                    backgroundColor: "#fafafa",
                    minWidth: 220,
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                  }}
                >
                  {/* <Typography
                    sx={{
                      fontWeight: 700,
                      color: "#d32f2f",
                      fontSize: "15px",
                      mb: 0.5,
                      wordBreak: "break-word",
                    }}
                  >
                    Approval Status: Rejected
                  </Typography> */}
                  {woData.workFlowLevel && (
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#1976d2",
                        fontWeight: 500,
                      }}
                    >
                      Workflow Level: {woData.workFlowLevel}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#d32f2f",
                      fontWeight: 500,
                      mt: 0.5,
                    }}
                  >
                    Rejection Reason:
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#333",
                        display: "block",
                        wordBreak: "break-word",
                      }}
                    >
                      {woData.reasonToCancel}
                    </span>
                  </Typography>
                </Box>
              </Box>
            )}
            {approvalContext?.fromApproval && approvalStatus !== "Pending" && (
              <Box
                sx={{
                  p: 1,
                  borderRadius: 2,
                  boxShadow: "0px 2px 8px #00000022",
                  backgroundColor: "#fafafa",
                  minWidth: 220,
                  mb: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color:
                      approvalStatus === "Approved" ? "#2e7d32" : "#d32f2f",
                    fontSize: "15px",
                    mb: 0.5,
                    wordBreak: "break-word",
                  }}
                >
                  Approval Status: {approvalStatus}
                </Typography>
                {approvalLevel && (
                  <Typography
                    sx={{ fontSize: "13px", color: "#1976d2", fontWeight: 500 }}
                  >
                    Workflow Level: {approvalLevel}
                  </Typography>
                )}
                {approvalStatus === "Rejected" && rejectedDescription && (
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#d32f2f",
                      fontWeight: 500,
                      mt: 0.5,
                    }}
                  >
                    Rejection Reason:
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#333",
                        display: "block",
                        wordBreak: "break-word",
                      }}
                    >
                      {rejectedDescription}
                    </span>
                  </Typography>
                )}
              </Box>
            )}
            {/* <MoreHoriz onClick={handleDot} sx={{ cursor: "pointer" }} />
              <Menu anchorEl={dotBL} open={Boolean(dotBL)} onClose={handleDot}>
                <MenuItem>Option 1</MenuItem>
                <MenuItem>Option 2</MenuItem>
                <MenuItem>Option 3</MenuItem>
              </Menu> */}
            <Box></Box>
          </Box>
        </Box>
        <TabContext value={value}>
          <Box
            sx={{
              ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                color: color.TabLabelcolor,
                // p: 0.5,
              },
              display: "flex",
              justifyContent: ui ? "center" : "space-between",
              width: ui ? "40%" : "100%",
            }}
          >
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{
                sx: { backgroundColor: color.TabLabelcolor, height: "3px" },
              }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="General" value="1" sx={{ textTransform: "none" }} />
              {!viewOnly && (
                <Tab
                  label="Work Plan"
                  value="2"
                  sx={{ textTransform: "none" }}
                />
              )}
              {!viewOnly && (
                <Tab
                  label="Work Assignment"
                  value="3"
                  sx={{ textTransform: "none" }}
                />
              )}

              {!viewOnly && (
                <Tab
                  label="Completion"
                  value="4"
                  sx={{ textTransform: "none" }}
                />
              )}
              {!viewOnly && (
                <Tab
                  label="Financial"
                  value="5"
                  sx={{ textTransform: "none" }}
                />
              )}
              {!viewOnly && (
                <Tab
                  label="Part Reservation"
                  value="6"
                  sx={{ textTransform: "none" }}
                />
              )}
            </TabList>
          </Box>
          <Box sx={{ mt: "1rem" }}>
            <TabPanel value="1" sx={{ p: 1 }}>
              {/* <CreateGeneral jobPlanIden={handleJobPlanId}/> */}
              <WOView
                woData={woData}
                direction={direction}
                isReadOnly={isClosedStatus}
              />
            </TabPanel>
            <TabPanel value="2">
              <WorkPlan
                jobPlanId={jobPlanId}
                workOrderId={workOrderId}
                direction={direction}
                refreshEnableDisable={() => getData()}
                enableDisable={getEffectiveEnableDisable()}
              />
            </TabPanel>
            <TabPanel value="3">
              <WorkAssignment
                jobPlanId={jobPlanId}
                workOrderId={workOrderId}
                direction={direction}
                enableDisable={getEffectiveEnableDisable()}
              />
            </TabPanel>
            <TabPanel value="4">
              <Completion
                workOrderId={workOrderId}
                direction={direction}
                refreshKey={refreshKey}
                // enableDisable={enableDisble}
                enableDisable={enableDisableActionAllow}
                assetId={woData.assetId}
              />
            </TabPanel>
            <TabPanel value="5">
              <WoCosting
                workOrderId={workOrderId}
                direction={direction}
                refreshKey={refreshKey}
                isReadOnly={isClosedStatus}
              />
            </TabPanel>
            <TabPanel value="6">
              <Partlist
                workOrderId={workOrderId}
                enableDisable={getEffectiveEnableDisable()}
                woStatus={woData.status}
                refreshWoStatus={getData}
                printName={`${woData.code} - ${woData.workOrderName} - Reservation`}
              />
            </TabPanel>
          </Box>
        </TabContext>

        {approvalContext?.fromApproval && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              mr: 2,
              mt: 1,
            }}
          >
            {approvalStatus === "Pending" ? (
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1 }}>
                <Button
                  onClick={() => setShowRejectModal(true)}
                  variant="contained"
                  size="small"
                  startIcon={<CloseIcon />}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#d32f2f",
                    "&:hover": {
                      backgroundColor: "#c62828",
                    },
                    minWidth: 100,
                  }}
                >
                  {workFlowFor === "WorkOrderClose" ? "Reopen" : "Reject"}
                </Button>
                <Button
                  onClick={handleApprove}
                  variant="contained"
                  size="small"
                  startIcon={<Check />}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#2e7d32",
                    "&:hover": {
                      backgroundColor: "#1b5e20",
                    },
                    minWidth: 100,
                  }}
                >
                  {workFlowFor === "WorkOrderClose"
                    ? "Ready To Close"
                    : "Approve"}
                </Button>
              </Box>
            ) : null}
          </Box>
        )}
      </Grid>
      <Grid
        container
        justifyContent={"flex-end"}
        item
        xs={direction === "column" ? 6 : 2.5}
        md={direction === "column" ? 6 : 1.5}
        lg={direction === "column" ? 6 : 1}
        sx={{
          boxShadow:
            direction === "column" ? "-1px 1px 7px 2px rgb(0 0 0 / 32%)" : 0,
          minHeight: "92vh",
          backgroundColor: "transparent",
        }}
      >
        <ListMenuWO
          contentPosition={contentPosition}
          data={woData}
          direction={direction}
          getData={getData}
          enableDisable={getEffectiveActionsAllow()}
        />
      </Grid>
      <UnifiedModal
        open={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject Work Order"
        description="Please provide a reason for rejection:"
        inputLabel="Rejection Description"
        inputValue={rejectDescription}
        onInputChange={(e) => setRejectDescription(e.target.value)}
        onCancel={() => setShowRejectModal(false)}
        onReject={handleReject}
        rejectButtonColor="error"
        rejectButtonVariant="contained"
        minRows={2}
        autoFocus={true}
      />
      {PrintLoader}
    </Grid>
  );
};

export default WO;
